import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { ArticleBlockContentGridCol } from '../ArticleBlockContentGridCol/ArticleBlockContentGridCol';

export const StyledArticleBlockContentGridCol = styled(ArticleBlockContentGridCol)`
  margin: ${spacing.space32} 0;
  @media (max-width: ${breakpoints.m}) {
    margin: ${spacing.space24} 0;
  }
`;
